import {
    PRESUPUESTADOR_UPDATE_TAKING_CAR
} from '../constants';

export function reducer(state, action) {
    if (action.type !== PRESUPUESTADOR_UPDATE_TAKING_CAR) return state;
    const takingCarPatent = action.data.takingCar.patente || action.data.takingCar.matricula
    // Se obtiene el indice en el array del objeto recibido por parametros
    const carIndex = state.entregaUsados.findIndex(car => car === action.data.takingCar || car.patente === takingCarPatent);

    // Se crea una copia del array de usados
    const newUsedCars = JSON.parse(JSON.stringify(state.entregaUsados));

    // Se actualiza el objeto del usado con los datos actualizados
    newUsedCars[carIndex] = {
        ...newUsedCars[carIndex],
        ...action.data.takingCar
    }

    // Se retorna el nuevo array de usados actualizado
    return {
        ...state,
        entregaUsados: newUsedCars
    }
}